import api from '../../../App/socket';

export const generateUserAPIToken = data => api.send({
    api: 'module',
    module: 'UserManagement',
    classMethod: 'GenerateApiKey',
    options: {
        where: { user_id: data.user_id },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/generate_user_api_token.request.js